// extracted by mini-css-extract-plugin
export var alt = "DistanceFilter-module--alt--5be85";
export var desktopOnly = "DistanceFilter-module--desktopOnly--5df2c";
export var distanceDropdown = "DistanceFilter-module--distanceDropdown--3545c";
export var main = "DistanceFilter-module--main--4f7ed";
export var mobileOnly = "DistanceFilter-module--mobileOnly--1c81e";
export var textLeft = "DistanceFilter-module--textLeft--aa013";
export var visuallyHidden = "DistanceFilter-module--visuallyHidden--70a83";